import usePreventClickOnDrag from '@activities/MainActivity/components/MainBanners/hooks/usePreventClickOnDrag';
import Column from '@components/Column';
import Image from '@components/Image';
import Indicator from '@components/Indicator';
import { BannerRow } from '@models/banner';
import { Fragment, useState } from 'react';
import Slider from 'react-slick';

import useGiftBanner from './hooks/useGiftBanner';
import styles from './styles.module.scss';

function Banner() {
  const banners = useGiftBanner();
  const [index, setIndex] = useState<number>(0);
  const { beforeChange, afterChange, onDragItemClick } = usePreventClickOnDrag();
  const onBannerClick = (banner: BannerRow) => {
    // TODO 배너 클릭 처리
    console.log(banner);
  };
  if (banners && banners.length > 0) {
    return (
          <Column align='center' fullWidth>
              {banners.length > 1 ? (
                  <Fragment>
                      <Slider dots={false}
                              beforeChange={beforeChange}
                              afterChange={(newIndex) => {
                                setIndex(newIndex);
                                afterChange();
                              }}>
                          {banners.map((banner, i) => (
                              <div className={styles.bannerWrapper}
                                   onClick={() => {
                                     onDragItemClick(() => onBannerClick(banner));
                                   }}
                                   key={banner.contentId} >
                                  <Image src={banner.imageUrl}
                                         alt='선물 배너'
                                         className={styles.banner} />
                              </div>
                          ))}
                      </Slider>
                      <Indicator total={banners.length}
                                          current={index} />
                  </Fragment>
              ) : (
                  <div className={styles.bannerWrapper}
                       onClick={() => onBannerClick(banners[0])} >
                      <Image src={banners[0].imageUrl}
                             alt='선물 배너'
                             className={styles.banner} />
                  </div>
              )}
              {/*
              <Text size='xl' fontWeight='bold' color={colors.gray7}>
                  기간 한정 선물 EVENT
              </Text> */}
          </Column>
    );
  }
  return (<Fragment/>);
}

export default Banner;
